define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginMenu"
], function(declare,ToolbarPluginMenu) {

	return declare(ToolbarPluginMenu, {
		validatePlugin: function(/*Context*/ctx) {
			// summary: only allow if BOMStructure is an attribute in context
			return ctx.getParent() ? ctx.getParent().BOMStructure: this.inherited(arguments);
		}
	});
});